import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { DashboardMessagesService } from '@services/dashboard-messages/dashboard-messages.service';
import { Models } from '@ibexfusion/models';
import { FormDirective } from '../../../directives/form/form.directive';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FormComponent } from '../../../components/default-form/form.component';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-dashboard-message-edit',
    templateUrl: './dashboard-message-edit.component.html',
    styleUrls: ['./dashboard-message-edit.component.scss'],
    providers: [DashboardMessagesService],
    standalone: false
})
export class DashboardMessageEditComponent implements OnInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;

  isLoading = true;
  pageActions: PageAction[];

  messageId: string = null;
  message: Models.DashboardMessage;

  selectedTabIndex = 0;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private dashboardMessageService: DashboardMessagesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private snackbar: SnackbarService
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.messageId = this.activatedRoute.snapshot.params['id'];
    if (this.messageId) {
      this.fetchMessage();
    } else {
      this.createMessage();
    }
  }

  fetchMessage() {
    this.dashboardMessageService.get(this.messageId).then(message => {

      this.message = message;
      if (this.message.translations[0].lang === 'en') {
        this.message.translations.reverse();
      }
      this.loadForm(this.message);
      this.isLoading = false;
      console.log(this.message);
    });
  }

  createMessage() {
    this.message = <Models.DashboardMessage>Models.ModelFactory.createModelInstanceByName('DashboardMessage');
    const messageEN = <Models.DashboardMessageTranslation>Models.ModelFactory.createModelInstanceByName('DashboardMessageTranslation');
    const messageDE = <Models.DashboardMessageTranslation>Models.ModelFactory.createModelInstanceByName('DashboardMessageTranslation');
    messageEN.lang = 'en';
    messageDE.lang = 'de';
    this.message.translations = [];
    this.message.translations.push(messageDE);
    this.message.translations.push(messageEN);
    this.loadForm(this.message);
    this.isLoading = false;
  }

  loadForm(model) {
    const formItem = DefaultFormComponent;
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);
    const viewContainerRef = this.formHost.viewContainerRef;
    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = model;
  }

  save() {
    this.isLoading = true;
    this.message.translations.map((translation, i) => {
      this.message.translations[i].message = this.cleanUpQuillContent(translation.message);
    });
    if (!this.messageId) {
      this.dashboardMessageService.create(this.message).then(result => {
        this.router.navigate(['dashboard-messages', result._id]).then(() => {
          this.snackbar.success('saved');
        });
      });
    } else {
      this.dashboardMessageService.update(this.messageId, this.message).then(result => {
        this.snackbar.success('saved');
      });
    }

  }

  quillChanged(event, translation) {
    translation.message = event;
  }

  cleanUpQuillContent(content) {
    if (!content) {
      return content;
    }
    while (content.match(/<p><br><\/p>$/gm)) {
      console.log('removing end spaces', content.match(/<p><br><\/p>$/gm));
      content = content.replace(/<p><br><\/p>$/gm, '');
    }
    return content;
  }

  public tabChange(event) {
    this.selectedTabIndex = event.index;
  }
}
